import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "flex header-context" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center justify-content-center align-self-stretch brand-logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.stenogram.pro/",
    target: "blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1)
const _hoisted_4 = { class: "flex-grow-1 flex align-items-center justify-content-center m-2 px-5" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "flex-none flex align-items-center justify-content-center my-2 mr-5 lang" }
const _hoisted_7 = { class: "flex-none flex align-items-center justify-content-end my-2 px-0 slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LangSelector = _resolveComponent("LangSelector")!
  const _component_HeaderNavigator = _resolveComponent("HeaderNavigator")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (r) => {
          return (_openBlock(), _createElementBlock("a", {
            href: r.link,
            key: r.name,
            class: "flex-grow-1 flex align-items-center justify-content-center"
          }, _toDisplayString(r.name), 9, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_LangSelector)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "right"),
        _createVNode(_component_HeaderNavigator)
      ])
    ])
  ]))
}